import React, { useState,useEffect } from "react";
import './dont-find-order.scss';
import CallIcon from '../../../assets/images/write-to-us-call.svg';
import CloseIcon from '../../../assets/images/write-to-us-close.svg';
import SubmitCheckboxTrukker from '../../../assets/images/submit-checkbox.svg';
import SubmitCheckboxAdeed from '../../../assets/adeed/images/submit-checkbox.svg';
import CalendarImg from "../../../assets/images/calendar-icon.svg";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../store/store";
import { Button, DatePicker, Form, Input, Row, Space, AutoComplete, Spin } from "antd";
import * as masterDataService from "../../../service/masterDataService";
import { RaiseComplaints } from "../../../service/helpAndSupport/helpAndSupportService";  // Import RaiseComplaints service
import useDebounce from "../../../util/useDebounce";
import { isAdeed } from "../../../constants/brand";

// ADEED Freight shows its blue copies of these images (src/assets/adeed).
const SubmitCheckbox = isAdeed ? SubmitCheckboxAdeed : SubmitCheckboxTrukker;

const DontFindOrder = ({ setDontFindOrder, dontFindOrder,setPageRefresh,pageRefresh }) => {
    const { t } = useTranslation();
    const [submitModel, setSubmitModel] = useState(false);
    console.log(submitModel, "submitModel")
    const [sourceOptionsWaiter, setSourceOptionsWaiter] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sourceOptions, setSourceOptions] = useState([]);
    const [form] = Form.useForm();
    const { user } = useStore();
    const [complaintId, setComplainId] = useState("")
      const [searchTerm, setSearchTerm] = useState("");
      const [destinationSearchTerm, setDestinationSearchTerm] = useState("");
    
      const debouncedSearchTerm = useDebounce(searchTerm, 500);
      const debouncedDestinationTerm = useDebounce(destinationSearchTerm, 500);

        useEffect(() => {
          if (debouncedSearchTerm.length > 2) {
            getCitySourceList(debouncedSearchTerm);
          }
        }, [debouncedSearchTerm]);
        
        useEffect(() => {
          if (debouncedDestinationTerm.length > 2) {
            getCitySourceList(debouncedDestinationTerm);
          }
        }, [debouncedDestinationTerm]);
    const handleOutsideClick = (e) => {
        if (e.target.id === "write-to-us-wrapper") {
            setDontFindOrder(false);
        }
    };

    // Handle API request for city locations
    const getCitySourceList = (value) => {
        if (value.length >= 2) {
            setSourceOptionsWaiter(true);
            masterDataService
                .getCountryStateCityMasterBasedOnSearch(value)
                .then((response) => {
                    if (response.status === 200) {
                        setSourceOptionsWaiter(false);
                        setSourceOptions(groupDataByType(response.data));
                    }
                })
                .catch(() => {
                    setSourceOptionsWaiter(false);
                    setSourceOptions([]);
                });
        }
    };

    // Group API response data
    function groupDataByType(apiResponse) {
        if (apiResponse && apiResponse.length > 0) {
            const groupedData = apiResponse.reduce((acc, item) => {
                const { type, key } = item;
                if (!acc[type]) {
                    acc[type] = [];
                }
                acc[type].push({
                    label: getOptionLabel(key, type),
                    value: key,
                    type: type,
                });
                return acc;
            }, {});

            let options = Object.keys(groupedData).map((key, index) => ({
                label: getCategoryLabel(key, index),
                sortOrder: getSortOrder(key),
                options: groupedData[key],
            }));
            return options.sort((a, b) => a.sortOrder - b.sortOrder);
        } else {
            return [];
        }
    }

    const getSortOrder = (type) => {
        switch (type) {
            case "country": return 1;
            case "state": return 2;
            case "city": return 3;
            default: return 0;
        }
    };

    const getOptionLabel = (key, type) => (
        <Space direction="horizontal" className="load-search-option">
            <span className="label-text">{key}</span>
        </Space>
    );

    const getCategoryLabel = (key, index) => (
        <>
            {key !== "country" && <hr className="hr-category-label" />}
            <span className="category-text">
                {key === 'state' ? t("FILTER_COMMON_STATE_LBL") : key === 'country' ? t("FILTER_COUNTRY_LBL") : t("FILTER_CITY_LBL")}
            </span>
        </>
    );

    const handleSubmitClick = () => {
        form.validateFields().then(async (values) => {
            setLoading(true);
            const payload = {

                supplierId: user?.userId,
                category: "Don't find order",
                moveDate:  values?.moveDate ? values?.moveDate.format('YYYY-MM-DD') : '',
                fromLocation: values?.fromLocation,
                toLocation: values?.toLocation,
                orderNumber: "",
                noOfTrucks: values?.truckCount,
                remarks: values?.remarks
            };

            try {
                const response = await RaiseComplaints(payload);  // API call to RaiseComplaints
                console.log("Complaint raised successfully:", response);
                setComplainId(response?.data?.data)
                setSubmitModel(true);
                setPageRefresh(!pageRefresh)
                // setDontFindOrder(false);
            } catch (error) {
                console.error("Error raising complaint:", error);
            } finally {
                setLoading(false);
            }
        }).catch((errorInfo) => {
            console.log('Validation failed:', errorInfo);
        });
    };

    const handleCloseClick = () => {
        setDontFindOrder(false);
        setSubmitModel(false);
    };

    return (
        <div className="write-to-us-wrapper" id="write-to-us-wrapper" onClick={handleOutsideClick} >
            {dontFindOrder && <div className="dont-find-model" >
                <Row className="write-to-us">
                    <span className="write-to-us-text">
                        {t("NEED_HELP_INVOICE_DONT_FIND_ORDER")}
                    </span>
                    <span>
                        <img src={CloseIcon} onClick={() => setDontFindOrder(false)} alt="close" style={{ cursor: 'pointer' }} />
                    </span>
                </Row>

                <Row className="order-id-missing">
                    {t("NEED_HELP_INVOICE_DONT_FIND_ORDER_DETAILS")}
                </Row>

                <Row className="team-reach-row">
                    <span className="image-call">
                        <img src={CallIcon} alt="call" />
                    </span>
                    <span className="message-text">{t("NEED_HELP_INVOICE_DFO_TEAM")}</span>
                </Row>

                <Form form={form} layout="vertical">
                    <Row className="input-field" style={{ marginBottom: '16px', width: '100%' }}>
                        <label className="input-label">{t("NEED_HELP_DFO_MOVE_DATE")}</label>
                        <Form.Item
                            name="moveDate"
                            rules={[{ required: true, message: t("NEED_HELP_DFO_MOVE_DATE_REQUIRED") }]}>
                            <DatePicker className="text-field" format="YYYY-MM-DD"
                                placeholder={t("NEED_HELP_DFO_MOVE_DATE_PLACEHOLDER")}
                                suffixIcon={<img style={{ width: "850%" }} src={CalendarImg} />} />
                        </Form.Item>
                    </Row>

                    <Row className="input-field" style={{ marginBottom: '16px', width: '100%' }}>
                        <label className="input-label">{t("NEED_HELP_DFO_FROM_LOC")}</label>
                        <Form.Item
                            name="fromLocation"
                            rules={[{ required: true, message: t("NEED_HELP_DFO_FROM_LOC_REQUIRED") }]}
                        >
                            <AutoComplete
                                className="text-field"
                                options={sourceOptions}
                                onSearch={ (val)=>  setSearchTerm(val)}
                                filterOption={false}
                                placeholder={t("NEED_HELP_DFO_FROM_LOC_PLACEHOLDER")}
                                suffixIcon={sourceOptionsWaiter ? <Spin size="small" /> : null}
                                onChange={(val) => form.setFieldValue("fromLocation", val)} // <== optional
                            />
                        </Form.Item>

                    </Row>

                    <Row className="input-field" style={{ marginBottom: '16px' }}>
                        <label className="input-label">{t("NEED_HELP_DFO_TO_LOC")}</label>
                        <Form.Item
                            name="toLocation"
                            rules={[{ required: true, message: t("NEED_HELP_DFO_TO_LOC_REQUIRED") }]}>
                            <AutoComplete
                                className="text-field"

                                options={sourceOptions}
                                onSearch={ (val)=>  setDestinationSearchTerm(val)}
                                placeholder={t("NEED_HELP_DFO_FROM_LOC_PLACEHOLDER")}
                                suffixIcon={sourceOptionsWaiter ? <Spin size="small" /> : null}
                            />
                        </Form.Item>
                    </Row>

                    <Row className="input-field" style={{ marginBottom: '16px' }}>
                        <label className="input-label">{t("NEED_HELP_DFO_NO_TRUCK")}</label>
                        <Form.Item
                            name="truckCount"
                            rules={[
                                { required: true, message: t("NEED_HELP_DFO_NO_TRUCK_REQUIRED") },
                                { pattern: /^[0-9]*$/, message: t("NEED_HELP_DFO_NO_TRUCK_REQUIRED_MSG") },
                                {
                                    validator: (_, value) => {
                                        if (!value || parseInt(value) <= 100) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error("Raise Upto 100 Trucks"));
                                    }
                                }
                            ]}>
                            <Input className="text-field"  maxLength={3} placeholder={t("NEED_HELP_DFO_ENTER")} />
                        </Form.Item>
                    </Row>

                    <Row className="input-field" style={{ marginBottom: '16px', style: '100%' }}>
                        <label className="input-label">{t("NEED_HELP_DFO_REMARKS")}</label>
                        <Form.Item
                            name="remarks"
                            rules={[{ required: true, message: t("NEED_HELP_DFO_REMARKS_REQUIRED") },
                                { max: 500, message: "Upto 500 words allowed" }
                            ]}>
                            <Input className="text-field" placeholder={t("NEED_HELP_DFO_ENTER")}    maxLength={500} />
                        </Form.Item>
                    </Row>
                </Form>

                <Row className="btn-row">
                    <Button className="cancle-btn" onClick={() => setDontFindOrder(false)}>
                        {t("COMMON_CANCEL_BTN")}
                    </Button>
                    <Button
                        className="submit-btn"
                        onClick={handleSubmitClick}
                        loading={loading}>
                        {t("COMMON_SUBMIT_BTN")}
                    </Button>
                </Row>
            </div>}

            {submitModel && (
                <div className="write-to-us-wrapper" >
                    <div className="write-to-us-submit-model">
                        <div className={`modal ${submitModel ? "open" : ""}`}>
                            <Row className="submitcheckbox">
                                <img src={SubmitCheckbox} alt="submit" />
                            </Row>
                            <Row className="successfull-msg">
                                {t("NEED_HELP_DFO_COMPLAINT_RAISED_SUCCESS")}
                                <span className="modal-title">{t("NEED_HELP_DFO_COMPLAINT_ID")} : {complaintId} {t("NEED_HELP_DFO_AGAINST")}</span>
                            </Row>
                            <Row className="teams-msg">
                                {t("NEED_HELP_DFO_TEAM_REACH")}
                            </Row>
                            <Row className="close-btn-wrapper">
                                <Button className="close-btn" onClick={handleCloseClick}>
                                    {t("NEED_HELP_DFO_CLOSE")}
                                </Button>
                            </Row>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DontFindOrder;
